import { Check, ArrowLeft, ShieldCheck } from "@phosphor-icons/react";
import MarkerStroke from "./MarkerStroke";
import useReveal from "./useReveal";
import "./home.css";
import "./HomePricing.css";

/*
 * Pricing data mirrors the SoftwareApplication offers in public/index.html —
 * keep the amounts (89.90 / 39.90) and the 30-day trial in sync there.
 * Monthly billing only.
 */

const formatPrice = (n) => n.toFixed(2).replace(/\.00$/, "");

const PLANS = [
  {
    id: "starter",
    name: "מתחילים",
    tagline: "למטפלים בתחילת הדרך",
    monthly: 39.9,
    limit: "עד 10 מטופלים",
    features: ["יומן חכם ותזכורות SMS", "תיק מטופל דיגיטלי", "סיכומי טיפול עם AI", "אישורי הגעה בוואטסאפ", "אפליקציה לנייד"],
    cta: "התחילו בחינם",
    featured: false,
  },
  {
    id: "pro",
    name: "מלא",
    tagline: "הכל כלול, ללא הגבלה",
    monthly: 89.9,
    limit: "מטופלים ומטפלים ללא הגבלה",
    features: [
      "כל מה שבמסלול מתחילים",
      "חשבוניות אוטומטיות (מורנינג)",
      "טפסים וחתימה דיגיטלית",
      "שאלונים למטופלים",
      "דוחות הכנסות וגבייה",
      "משימות, לידים והתראות",
      "חדרי טיפול ויומנים מרובים",
    ],
    cta: "התחילו 30 ימי ניסיון",
    featured: true,
  },
];

function HomePricing() {
  const ref = useReveal();

  return (
    <section id="pricing" className="home-section home-section--white hpri" aria-labelledby="hpri-title">
      <div className="home-container">
        <div className="home-head home-head--center">
          <h2 id="hpri-title" className="home-h2 home-h2--display">
            מחיר{" "}
            <span className="home-mark">
              פשוט.
              <MarkerStroke />
            </span>{" "}
            בלי אותיות קטנות.
          </h2>
          <p className="home-sub">
            למשתמש, לחודש, לא כולל מע״מ. ללא עמלות הקמה, ללא התחייבות, ביטול בכל עת.
          </p>
        </div>

        <div className="hpri-grid home-reveal" ref={ref}>
          {PLANS.map((plan) => (
            <div
              className={`hpri-plan home-card home-bubble--lg${plan.featured ? " hpri-plan--featured" : ""}`}
              key={plan.id}
            >
              {plan.featured && <span className="hpri-badge">הכי פופולרי</span>}
              <div className="hpri-plan-name">{plan.name}</div>
              <div className="hpri-plan-tagline">{plan.tagline}</div>

              <div className="hpri-price">
                <span className="hpri-price-amount" dir="ltr">
                  {formatPrice(plan.monthly)} ₪
                </span>
                <span className="hpri-price-period">לחודש · למשתמש</span>
              </div>
              <div className="hpri-price-note">לא כולל מע״מ · ביטול בכל עת</div>
              <div className="hpri-limit">{plan.limit}</div>

              <ul className="hpri-features">
                {plan.features.map((f) => (
                  <li key={f}>
                    <Check size={15} weight="bold" />
                    {f}
                  </li>
                ))}
              </ul>

              <a href="#contact" className={`home-btn ${plan.featured ? "home-btn--primary" : "home-btn--outline"}`}>
                {plan.cta}
                <ArrowLeft size={17} weight="bold" />
              </a>
            </div>
          ))}
        </div>

        <p className="hpri-trial">
          <ShieldCheck size={18} weight="fill" />
          <span>
            <strong>30 ימי ניסיון חינם</strong> בכל מסלול · ללא כרטיס אשראי · תמיכה אנושית בעברית
          </span>
        </p>
      </div>
    </section>
  );
}

export default HomePricing;
